import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { Common } from '../model/common.model';
import { LoadingService } from './loading.service';

@Injectable()
export class HTTPStatus {
  private requestInFlight$: BehaviorSubject<boolean>;
  constructor() {
    this.requestInFlight$ = new BehaviorSubject(false);
  }

  setHttpStatus(inFlight: boolean) {
    this.requestInFlight$.next(inFlight);
  }

  getHttpStatus(): Observable<boolean> {
    return this.requestInFlight$.asObservable();
  }
}

@Injectable()
export class HTTPListener implements HttpInterceptor {
  constructor(private status: HTTPStatus) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        return event;
      }),
      catchError(error => {
        return Observable.throw(error);
      }),
      finalize(() => {
        this.status.setHttpStatus(false);
      })
    )
  }
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private loadingService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = Common.getWithExpiry('SessionToken');
    const authorizedReq = token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;
    return next.handle(authorizedReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status !== 401 || this.router.getCurrentNavigation() !== null) {
          return throwError(err);
        }
        this.loadingService.LoadingMessage('stop');
        const isSales = !!Common.getWithExpiry('SalesUserID');
        ['SessionToken', 'CustID', 'UserID', 'warehouse', 'UserType',
         'Permission', 'IsManager', 'Name', 'ProfileLog',
         'SalesUserID', 'SalesUserType'].forEach(k => Common.removeWithExpiry(k));
        this.router.navigate([isSales ? '/sales-login' : '/login']);
        return throwError(err);
      })
    );
  }
}